import { Types } from '../actions/datoscliente';

export default function datosclienteReducer(
    state = {
        tipoEmailContactoResponse: {}, 
        contactoPorTipoEmailResponse: {}, 
        tiendas: {}, 
        loading: true, 
        success: false, 
        successContacto: false, 
        error: "" ,
        contactoResponse: {}
    }, action) {
    switch (action.type) {
        case Types.GET_DATOS_CLIENTE:
            return {...state, loading: true }
        case Types.DATOS_CLIENTE_SUCCEEDED:
            return {...state, success: true, loading: false, tipoEmailContactoResponse: action.tipoEmailContactoResponse }
        case Types.GET_CONTACTO_EMAIL_REQUEST:
            return {...state, loading: true }
        case Types.CONTACTO_EMAIL_SUCCEEDED:
            return {...state, success: true, loading: false, contactoPorTipoEmailResponse: action.contactoPorTipoEmailResponse };
        case Types.GET_TIENDA_REQUEST:
            return {...state, loading: true }
        case Types.GET_TIENDA_REQUEST_SUCCEEDED:
            return {...state, success: true, loading: false, tiendas: action.tiendas };
        case Types.DATOS_CLIENTE_ERROR:
            return {...state, error: action.error, success: false, successContacto: false, loading: false};
        case Types.CREATE_CONTACTO_REQUEST:
            return {...state, success: false, successContacto: false, loading: true }
        case Types.UPDATE_CONTACTO_REQUEST:
            return {...state, success: false, successContacto: false, loading: true }
        case Types.DELETE_CONTACTO_REQUEST:
            return {...state, success: false, successContacto: false, loading: true }
        case Types.CONTACTO_REQUEST_SUCCEEDED:
            return {...state, loading: false, success: true, successContacto: true, contactoResponse: action.contactoResponse};
        default:
            return state;
    }
}